import AbstractCompositeSpecification from "./AbstractCompositeSpecification.js";

/**
 * `orSpecification` is a concrete implementation
 * of `abstractCompositeSpecification` representing a server side
 * `or` operation of a list of other account specifications.
 */
export default class OrSpecification extends AbstractCompositeSpecification {
	accept(visitor, additionalInformation) {
		return visitor.visitOrSpecification(this, additionalInformation);
	}

	isOr() {
		return true;
	}

	static getType() {
		return "OrSpecification";
	}
}
